import React from 'react'

import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'

import { Container } from '../../../../../components'
import { BaseProps } from '../types'
import { ApartmentDeadline, WorkorderCluster } from '../../../../../models'
import { toMMDDYYYY } from '../../../../../helpers'
import { typographyStyle } from '../../../../../theme/typographyStyle'
import { DateTime } from 'luxon'

interface Props extends BaseProps {
    workorderCluster: WorkorderCluster
    onClick: (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
        workorderCluster: WorkorderCluster,
    ) => void
}

export const EventTypeWorkorderCluster = (props: Props) => {
    const { theme, onClick, workorderCluster } = props

    const workorderIdArray = workorderCluster.workorder_ids.split(',')

    const timelineLabel = (
        <Container>
            <span
                style={{
                    ...typographyStyle(theme.typography.body2),
                    fontWeight: 700,
                    marginRight: theme.spacing(1),
                }}
            >
                {DateTime.fromISO(workorderCluster.start_date).toFormat(
                    'MM/dd/yyyy',
                )}
            </span>
            {workorderCluster.end_date && (
                <>
                    <span
                        style={{
                            ...typographyStyle(theme.typography.body2),
                            fontWeight: 300,
                            marginRight: theme.spacing(1),
                        }}
                    >
                        -
                    </span>

                    <span
                        style={{
                            ...typographyStyle(theme.typography.body2),
                            fontWeight: 700,
                        }}
                    >
                        {DateTime.fromISO(workorderCluster.end_date).toFormat(
                            'MM/dd/yyyy',
                        )}
                    </span>
                </>
            )}
        </Container>
    )

    return (
        <Container
            style={{
                paddingLeft: theme.spacing(1),
                alignItems: 'center',
            }}
            onClick={(e) => {
                onClick(e, props.workorderCluster)
            }}
        >
            <span
                style={{
                    ...typographyStyle(theme.typography.body1),
                    fontWeight: 700,
                    marginRight: theme.spacing(2),
                }}
            >
                {workorderCluster.service?.name ?? 'No Service'} (
                {workorderIdArray.length})
            </span>
            {timelineLabel}
        </Container>
    )
}
